import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column, MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';
// import { RowDataCompleted } from 'src/reducers/completeorderfile';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import {
    Tooltip,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField,
    DialogProps,
    FormControlLabel,
    withStyles,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import VisibilityIcon from '@material-ui/icons/Visibility';
import RedoIcon from '@material-ui/icons/Redo';
import { TatData } from 'src/reducers/fileUpload';
import { RowDataManufactur } from 'src/reducers/manufactur';
import { RedesignReasons } from 'src/reducers/completeorderfile';

interface TableStateDate {
    columns: Array<Column<RowDataManufactur>>;
    data: RowDataManufactur[];
}

interface SubitReDesignCodes {
    producttype: string;
    category: string;
    reason: string;
}

export interface DesignReadyViewProps {
    designReadyData: RowDataManufactur[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (filePath: string, fileName: string) => void;
    onBulkDownload: (completedData: RowDataManufactur[] | RowDataManufactur) => void;
    onBulkDownloadStl: (completedData: RowDataManufactur[] | RowDataManufactur, filetype: string) => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;
    orderDataTat: TatData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        reasonBox: {
            minWidth: '500px'
        },
        qcreq: {
            fontSize: '10px',
            textAlign: 'right',
            paddingRight: '24px',
            fontStyle: 'italic',
            color: 'red'
        },
        button: {
            margin: theme.spacing(1),
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

const DesignReadyView: React.StatelessComponent<DesignReadyViewProps> = (props) => {
    const classes = useStyles({});

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('xs');
    const [fullWidthReason] = React.useState(true);
    const [maxWidthReason] = React.useState<DialogProps['maxWidth']>('md');

    const [tat, setTat] = React.useState('Next Day 7 AM');
    const [ptype, setPtype] = React.useState('');
    const [ptypeModel, setPtypeModel] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [categoryArray, setCategoryArray] = React.useState<string[]>([]);
    const [categoryModelArray, setCategoryModelArray] = React.useState<string[]>([]);
    const [categoryModel, setCategoryModel] = React.useState('');
    const [reason, setReason] = React.useState<SubitReDesignCodes[]>([]);
    const [reasonModel, setReasonModel] = React.useState<SubitReDesignCodes[]>([]);
    const [msg, setMsg] = React.useState('');
    const [msgApp, setMsgApp] = React.useState('');
    const [orderno, setOrderno] = React.useState('');
    const [userName, setuserName] = React.useState('');

    const [openRe, setOpenRe] = React.useState(false);
    const [openDesignReason, setOpenDesignReason] = React.useState(false);
    const [openModelReason, setOpenModelReason] = React.useState(false);

    const duplicateCateDesign = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(iddup => {
                return data.find(a => a.category === iddup && a.producttype !== 'Model');
            });
    };

    const duplicateCateModel = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(iddup => {
                return data.find(a => a.category === iddup && a.producttype === 'Model');
            });
    };

    const changeDesignCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategory(event.target.value);
            setOpenDesignReason(true);
        } else {
            setReason(reason.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryArray.indexOf(event.target.value);
            categoryArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryArray(categoryArray);
        }
    };
    const changeModelCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategoryModel(event.target.value);
            setOpenModelReason(true);
        } else {
            setReasonModel(reasonModel.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryModelArray.indexOf(event.target.value);
            categoryModelArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryModelArray(categoryModelArray);
        }
    };

    const changeDesignReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArray: SubitReDesignCodes = {
            producttype: 'Design',
            category: category,
            reason: event.target.value
        };
        reason.push(newArray);
        setReason(reason);
        categoryArray.push(category);
        setCategoryArray(categoryArray);
        setOpenDesignReason(false);
    };
    const changeModelReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArrayModel: SubitReDesignCodes = {
            producttype: 'Model',
            category: categoryModel,
            reason: event.target.value
        };
        reasonModel.push(newArrayModel);
        setReasonModel(reasonModel);
        categoryModelArray.push(categoryModel);
        setCategoryModelArray(categoryModelArray);
        setOpenModelReason(false);
    };

    const handleClickOpenRe = (casno: string, user: string) => {
        setMsg('');
        setPtype('Design');
        setPtypeModel('Model');
        setCategory('0');
        setCategoryModel('0');
        setOrderno(casno);
        setuserName(user);
        setTat('Next Day 7 AM');
        setOpenRe(true);
        setReasonModel([]);
        setReason([]);
        setCategoryModelArray([]);
        setCategoryArray([]);
    };
    const handleCloseRe = () => {
        setOpenRe(false);
    };
    const onCloseDesignReason = () => {
        setOpenDesignReason(false);
    };
    const onCloseModelReason = () => {
        setOpenModelReason(false);
    };
    const handleSubmitRe = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                tat: tat,
                msg: msg.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            reasons: reason.concat(reasonModel),
            id: 'rword'
        };
        setOpenRe(false);
        props.redesignRequest(columns);
    };

    const [openAppro, setOpenAppro] = React.useState(false);
    const handleClickOpenApp = (ordernumber: string) => {
        setMsgApp('');
        setOrderno(ordernumber);
        setOpenAppro(true);
    };
    const handleCloseApp = () => {
        setOpenAppro(false);
    };
    const handleSubmitApp = () => {
        setOpenAppro(false);
        const array = [{
            orderno: orderno,
            approval_reqd: '1',
            remarks: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
        }];
        props.approvalRequired(array);
    };

    const msgAppChange = (msgValue: string) => {
        setMsgApp(msgValue);
    };

    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [rowDatastl, setRowData] = React.useState<RowDataManufactur[] | RowDataManufactur>([]);

    const openDownloadDialog = (rowdata: RowDataManufactur[] | RowDataManufactur) => {
        setRowData(rowdata);
        setOpenDownload(true);
    };
    const closeDownloadDialog = () => {
        setOpenDownload(false);
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        props.onBulkDownloadStl(rowDatastl, fileTypes.toString());
    };

    const [state] = React.useState<TableStateDate>({
        columns: [
            {
                title: 'Case No',
                field: 'orderno',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.qc_required === '0' ?
                                rowData.orderno
                                :
                                rowData.qc_required === '1' ?
                                    <div>
                                        {rowData.orderno}
                                        <div className={classes.qcreq}>
                                            QC Required
                                        </div>
                                    </div>
                                    :
                                    rowData.qc_required === '2' ?
                                        <div>
                                            {rowData.orderno}
                                            <div className={classes.qcreq} onClick={() => handleClickOpenApp(rowData.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                Approve
                                            </div>
                                        </div>
                                        :
                                        rowData.orderno
                        }
                    </div>
                ),
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'Customer Name',
                field: 'customername',
                filtering: false,
                cellStyle: {
                    padding: '0px',
                    fontSize: '13px'
                }
            },
            {
                title: 'Received on',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'Completed On',
                field: 'completedon',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Action',
                field: 'fdownload',
                export: false,
                // cellStyle: {
                //   backgroundColor: '#039be5',
                //   color: '#FFF'
                // },
                render: rowData => (
                    <div style={{ display: 'flex' }}>
                        <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Re-Design" placement="top">
                            <IconButton aria-label="view" onClick={() => handleClickOpenRe(rowData.orderno, rowData.labname)}>
                                <RedoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {rowData.fdownload === '0' ?
                            <Tooltip title="Not yet Downloaded" placement="top">
                                <div style={{ width: '20px', height: '20px', background: 'red', borderRadius: '50%', padding: '5px', margin: 'auto' }} />
                            </Tooltip>
                            :
                            <Tooltip title="Downloaded" placement="top">
                                <div style={{ width: '20px', height: '20px', background: 'green', borderRadius: '50%', padding: '5px', margin: 'auto' }} />
                            </Tooltip>
                        }
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        data: props.designReadyData
    });

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        {props.isDownloading === true ? <CircularProgress className={classes.buttonSend} /> : null}
                        <Dialog
                            open={openRe}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidthReason}
                            maxWidth={maxWidthReason}
                        >
                            <DialogTitle id="form-dialog-title">Re-Design Request on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <DialogContentText>
                                    Please select Reason, TAT and enter Remarks to submit.
                                </DialogContentText>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined"
                                                defaultValue="0"
                                                onChange={(event) => setPtype(event.target.value as string)}
                                                value={ptype}
                                            >
                                                <MenuItem value="Design" disabled>Design</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicatePtype(props.redesignReasons).map((proType, indexRe1) => (
                                                    proType!.producttype !== 'Model' ? <MenuItem id={proType!.rowno} value={proType!.producttype}>{proType!.producttype}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtype(event.target.value as string)}
                                            value={ptype}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-1"
                                                defaultValue="0"
                                                onChange={(event) => setCategory(event.target.value as string)}
                                                value={category}
                                            >
                                                <MenuItem value="0" disabled>Select Category</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cate, indexRe1) => (
                                                    cate!.producttype !== 'Model' ? <MenuItem id={cate!.rowno} value={cate!.category}>{cate!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                    {
                                        duplicateCateDesign(props.redesignReasons).map((cate, indexRe1) => (
                                            typeof (cate) === 'object' && cate!.producttype !== 'Model' ?
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`category${indexRe1}`}
                                                                checked={categoryArray.indexOf(cate!.category) !== -1 ? true : false}
                                                                value={cate!.category}
                                                                onChange={changeDesignCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={cate!.category}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }

                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-3"
                                                defaultValue="0"
                                                onChange={(event) => setPtypeModel(event.target.value as string)}
                                                value={ptypeModel}
                                            >
                                                <MenuItem value="Model" disabled>Model</MenuItem>
                                            </Select>
                                        </FormControl> */}
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtypeModel(event.target.value as string)}
                                            value={ptypeModel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-4"
                                                defaultValue="0"
                                                onChange={(event) => setCategoryModel(event.target.value as string)}
                                                value={categoryModel}
                                            >
                                                <MenuItem value="0" disabled>Select Category (Model)</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cateModel, indexRe1) => (
                                                    cateModel!.producttype === 'Model' ? <MenuItem id={cateModel!.rowno} value={cateModel!.category}>{cateModel!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                    {
                                        duplicateCateModel(props.redesignReasons).map((cateModel, indexRe1) => (
                                            typeof (cateModel) === 'object' && cateModel!.producttype === 'Model' ?
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`categoryModel${indexRe1}`}
                                                                checked={categoryModelArray.indexOf(cateModel!.category) !== -1 ? true : false}
                                                                value={cateModel!.category}
                                                                onChange={changeModelCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={cateModel!.category}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }
                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={5}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-6"
                                                defaultValue="Next Day 7 AM"
                                                onChange={(event) => setTat(event.target.value as string)}
                                                value={tat}
                                            >
                                                {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                    <MenuItem id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => setMsg(event.target.value as string)}
                                                value={msg}
                                                required
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseRe} color="secondary">
                                    Cancel
                                </Button>
                                <Button
                                    size="small"
                                    disabled={(msg === '' || (reason.length === 0 && reasonModel.length === 0)) ? true : false}
                                    onClick={handleSubmitRe}
                                    color="primary"
                                >
                                    Re-Design
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDesignReason}
                            onClose={onCloseDesignReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{category} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-2"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeDesignReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsRe, indexRe1) => (
                                                            reasonsRe.producttype !== 'Model' && reasonsRe.category === category ?
                                                                <MenuItem id={reasonsRe.rowno} value={reasonsRe.code}>{reasonsRe.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openModelReason}
                            onClose={onCloseModelReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{categoryModel} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-5"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeModelReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason (Model)</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsModl, indexRe1) => (
                                                            reasonsModl.producttype === 'Model' && reasonsModl.category === categoryModel ?
                                                                <MenuItem id={reasonsModl.rowno} value={reasonsModl.code}>{reasonsModl.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openAppro}
                            onClose={handleCloseApp}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Approve Design on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => msgAppChange(event.target.value as string)}
                                                value={msgApp}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseApp} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={handleSubmitApp} disabled={msgApp === ''} color="primary">
                                    Approve
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDownload}
                            onClose={closeDownloadDialog}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">What to download?</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    {
                                        downloadFiletypes.map((typeFile, indexRe1) => (
                                            <Grid item xs={6} sm={4} md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            id={`filetype${indexRe1}`}
                                                            checked={fileTypes.indexOf(typeFile) > -1}
                                                            value={typeFile}
                                                            onChange={filetypeChange}
                                                            name="Filetype"
                                                        />
                                                    }
                                                    label={typeFile}
                                                />
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={submitStlDownload} disabled={fileTypes.length > 0 ? false : true} color="primary">
                                    Download
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Design Ready"
                        columns={state.columns}
                        data={props.designReadyData}
                        localization={{
                            toolbar: {
                                nRowsSelected: '{0} order(s) selected',
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        components={{
                            Toolbar: some => (
                                <div className={classes.mtable}>
                                    <MTableToolbar {...some} />
                                </div>
                            )
                        }}
                        options={{
                            // filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '0px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            exportButton: true,
                            exportAllData: true,
                        }}
                        actions={[
                            {
                                icon: () => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<CloudDownloadIcon />}
                                    >
                                        Download zip
                                    </Button>),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowData) => {

                                    if (!props.isDownloading) {
                                        props.onBulkDownload(rowData);
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<CloudDownloadIcon />}
                                    >
                                        Download STL/PTS/3OX
                                    </Button>),
                                tooltip: 'Download STL files/PTS/3OX',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata);
                                    }
                                }
                            }
                        ]}
                    />
                    <div style={{ display: 'flex', padding: '10px 5px' }}>
                        <div style={{ width: '20px', height: '20px', background: 'red', borderRadius: '50%', padding: '5px' }} />
                        <div style={{ padding: '0 10px' }}>
                            - Not yet Downloaded
                        </div>
                        <div style={{ width: '20px', height: '20px', background: 'green', borderRadius: '50%', padding: '5px' }} />
                        <div style={{ padding: '0 10px' }}>
                            - Downloaded
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default DesignReadyView;



// WEBPACK FOOTER //
// ./src/components/layouts/DesignReadyView.tsx